import React from 'react';

const TURNSTILE_SCRIPT_SRC =
  'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
const TURNSTILE_ONLOAD = '__cosyndTurnstileOnLoad';

let turnstileScriptPromise = null;

function getTurnstileSiteKey() {
  return process.env.REACT_APP_TURNSTILE_SITE_KEY || '';
}

function loadTurnstileScript() {
  if (typeof window === 'undefined') {
    return Promise.resolve();
  }

  if (window.turnstile) {
    return Promise.resolve();
  }

  if (turnstileScriptPromise) {
    return turnstileScriptPromise;
  }

  turnstileScriptPromise = new Promise((resolve, reject) => {
    window[TURNSTILE_ONLOAD] = () => {
      resolve();
    };

    const script = document.createElement('script');
    script.src = `${TURNSTILE_SCRIPT_SRC}&onload=${TURNSTILE_ONLOAD}`;
    script.onerror = () => {
      turnstileScriptPromise = null;
      reject(new Error('Turnstile failed to load'));
    };
    document.head.appendChild(script);
  });

  return turnstileScriptPromise;
}

class Turnstile extends React.Component {
  constructor(props) {
    super(props);
    this.widgetId = null;
    this.mounted = false;
  }

  componentDidMount() {
    this.mounted = true;
    this.renderWidget();
  }

  componentWillUnmount() {
    this.mounted = false;
    this.removeWidget();
  }

  renderWidget() {
    const siteKey = this.props.siteKey || getTurnstileSiteKey();

    if (!siteKey || !this.container) {
      return;
    }

    loadTurnstileScript()
      .then(() => {
        if (
          !this.mounted ||
          !this.container ||
          !window.turnstile ||
          this.widgetId
        ) {
          return;
        }

        this.widgetId = window.turnstile.render(this.container, {
          sitekey: siteKey,
          action: this.props.action || 'signup',
          callback: (token) => {
            if (this.props.onVerify) {
              this.props.onVerify(token);
            }
          },
          'expired-callback': () => {
            if (this.props.onExpire) {
              this.props.onExpire();
            }
          },
          'error-callback': () => {
            if (this.props.onError) {
              this.props.onError();
            }
          },
        });
      })
      .catch(() => {
        if (this.mounted && this.props.onError) {
          this.props.onError();
        }
      });
  }

  removeWidget() {
    if (typeof window !== 'undefined' && window.turnstile && this.widgetId) {
      window.turnstile.remove(this.widgetId);
      this.widgetId = null;
    }
  }

  reset() {
    if (typeof window !== 'undefined' && window.turnstile && this.widgetId) {
      window.turnstile.reset(this.widgetId);
    }
  }

  render() {
    return (
      <div
        className="turnstile-widget mt-20px"
        ref={(node) => {
          this.container = node;
        }}
      />
    );
  }
}

export default Turnstile;



// WEBPACK FOOTER //
// src/components/Auth/Turnstile.jsx